const deng51urlConfig = "https://www.deng51.com/api/v1";

export default deng51urlConfig